import { put, fork, take, call } from 'redux-saga/effects';
import { routeActions } from 'ng-redux-route';
import { takeFetch } from 'redux/helpers';
import * as serviceActions from '../../../services/actions';
import * as projectActions from '../../project/actions';
import * as fieldsetActions from '../editor/general/fieldset/actions';
import * as actions from './actions';

function* getCompany() {
  const { success } = yield takeFetch(serviceActions.api.configuration.company.GET);
  if (success) {
    yield put(actions.setCompany.end({ workingTimings: success.data.workingTimings }));
  }
}

function* getTemplate(companyId) {
  const { success } = yield takeFetch(serviceActions.api.configuration.project.GET_TEMPLATE);
  if (success && success.data) {
      yield put(fieldsetActions.init.begin({ project: success.data , companyId}))
  }
  else {
      ttb.Notifications.ShowErrorMessage('Project Configuration', 'Project creation failed');
      yield put(routeActions.back());
  }
}

function* getCompanyList() {
  const { success } = yield takeFetch(serviceActions.api.configuration.company.GET_LIST);
  if (success) {
    yield put(actions.init.company.begin({ values: success.data }));
  }
}

function* createProject() {
  const { success } = yield takeFetch(serviceActions.api.configuration.project.UPSERT);
  if (success) {
    yield put(actions.create.end());
    yield put(projectActions.viewer.init.begin());
    yield put(routeActions.back());
  } else {
    ttb.Notifications.ShowErrorMessage('Project Configuration', 'Cannot create a project');
  }
}

function* init() {
  while (true) {
    const { companyId } = yield take(actions.INIT.SELF);
    yield put(serviceActions.api.configuration.project.getTemplate.request({ companyId }));
    yield call(getTemplate, companyId);
    yield put(serviceActions.api.configuration.company.getList.request());
    yield fork(getCompanyList);
  }
}

function* create() {
  while (true) {
    const fields = yield take(actions.CREATE.BEGIN);
    yield put(serviceActions.api.configuration.project.upsert.request(fields));
    yield fork(createProject);
  }
}

function* initCompany() {
  while (true) {
    const { values } = yield take(actions.INIT.COMPANY.BEGIN);
    const companyOptions = values.filter(c=> c.isActive).map(c => ( { id: c.companyId, title: c.name }));
    yield put(actions.init.company.end({ companyOptions }));
  }
}

function* setCompany() {
  while (true) {
    const { companyId } = yield take(actions.SET_COMPANY.BEGIN);
    yield put(serviceActions.api.configuration.company.get.request({ id: companyId }));
    yield fork(getCompany);
  }
}

export default function* creator() {
  yield fork(init);
  yield fork(initCompany);
  yield fork(create);
  yield fork(setCompany);
}



// WEBPACK FOOTER //
// ../redux/store/configuration/project/creator/saga.js